/**
 * Latest reviews на главной.
 */

import { GOOGLE_REVIEWS_URL, LATEST_REVIEWS } from "../config/reviews";
import "./HomeReviews.css";

function GoogleMark() {
    return (
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
        </svg>
    );
}

function ReviewStars({ rating }) {
    return (
        <div className="review-card__stars" aria-label={`${rating} out of 5`}>
            {[1, 2, 3, 4, 5].map((i) => (
                <svg key={i} width="14" height="14" viewBox="0 0 31 31" fill="none">
                    <path d="M15.5 3.5L18.4 11.5L26.9 11.8L20.3 17.1L22.6 25.2L15.5 20.5L8.4 25.2L10.7 17.1L4.1 11.8L12.6 11.5Z" fill={i <= rating ? "#FABB05" : "#DADCE0"} />
                </svg>
            ))}
        </div>
    );
}

function HomeReviews({ onSendEmail }) {
    return (
                    <>
                    {/* Full-screen banner with reviews */}
                    <div style={{
                        width: '100%',
                        maxWidth: '1250px',
                        margin: '3rem auto 0',
                        padding: '0',
                        boxSizing: 'border-box',
                    }}>
                        <div className="reviews-container" style={{
                            width: '100%',
                            background: 'linear-gradient(155deg, #2e2e2e 0%, #272727 40%, #1f1f1f 100%)',
                            border: '3px solid #000000',
                            borderRadius: '20px',
                            padding: '1.5rem 1.5rem 2rem',
                            boxSizing: 'border-box',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '1.5rem',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1)',
                        }}>
                            <p style={{
                                margin: 0,
                                fontFamily: "'Montserrat', sans-serif",
                                fontStyle: 'normal',
                                fontWeight: 700,
                                fontSize: '1.85rem',
                                lineHeight: '1.2',
                                color: '#ffffff',
                                textAlign: 'center',
                            }}>
                                Latest reviews
                            </p>

                            {/* Review cards */}
                            <div className="reviews-grid">
                                {LATEST_REVIEWS.map((review) => (
                                    <article key={review.name} className="review-card">
                                        <div className="review-card__head">
                                            <img
                                                className="review-card__avatar"
                                                src={review.avatar}
                                                alt=""
                                                width="44"
                                                height="44"
                                            />
                                            <div className="review-card__meta">
                                                <div className="review-card__name">{review.name}</div>
                                                <ReviewStars rating={review.rating} />
                                                <div className="review-card__sub">
                                                    <GoogleMark />
                                                    <span>{review.date}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <p className="review-card__text">{review.text}</p>
                                    </article>
                                ))}
                            </div>

                            {/* Buttons row */}
                            <div className="reviews-actions">
                                <a
                                    className="reviews-btn"
                                    href={GOOGLE_REVIEWS_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <GoogleMark />
                                    Reviews on Google
                                </a>
                                <button type="button" className="reviews-btn" onClick={onSendEmail}>
                                    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none">
                                        <path d="M12 3.5l2.1 5.3 5.7.4-4.4 3.6 1.4 5.5L12 15.6 7.2 18.3l1.4-5.5-4.4-3.6 5.7-.4L12 3.5z" fill="#000"/>
                                    </svg>
                                    Leave a review
                                </button>
                            </div>
                        </div>{/* end dark banner */}
                    </div>{/* end outer wrapper */}
                    </>
    );
}

export default HomeReviews;
// pages/HomeReviews.js
